import styled from 'styled-components';
import { Button } from '../../Button';
import { T } from "../../../styles/Theme";
import IconBanner from '../../../assets/icons/Banner/IconBanner';
import { CheckFeasibilityGTM } from '../../../utils/GoogleTagManager';
import { AnswersContext } from '../../../contexts/AnswersContext';
import { useContext } from 'react';
import { DataContext } from '../../../contexts/DataContext';
import { getActivitiesToDo, getConectedDevicesAlternatives, getPlanSelected } from '../../../utils/common';

export const Banner = () => {
  // const url = 'https://www.entel.cl/empresas/pre-factibilidad/?origenWeb=prefactibilidad-recomendador';
  const url = 'https://empresas.entel.cl/contratacion/fijo/factibilidad?origen=prefactibilidad-recomendador';

  const [answers, ] = useContext(AnswersContext);
  const [finalForm, ] = useContext(DataContext);

  const handleClick = () => {
    CheckFeasibilityGTM(window, answers.email, answers.phone, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm));
    window.open(url, '_blank')
  }

  return (
    <>
    <BannerContainer>
      <div className='svgIcon'>
        <IconBanner/>
      </div>
      <div className='text-banner'>
        ¿Quieres contar con el mejor internet fibra óptica en tu dirección?
      </div>
      <div className='button-box'>
        <ButtonStyled
          onClick={() => handleClick()}
        >
          Revisa tu factibilidad
        </ButtonStyled>
      </div>
      </BannerContainer>
    </>
  );
};

const BannerContainer = styled.div`
  display: block;
  width: 535px;
  height: 67px;
  margin: auto 50px 10px 50px;
  border-radius: 10px;
  background: ${T.blue};
  font-family: 'Barlow', sans-serif;

  .svgIcon {
    display: inline-block;
    width: 65px;
    height: 67px;
    padding: 16px 0 0 20px;
  }

  .text-banner {
    display: inline-block;
    position: relative;
    height: 67px;
    max-width: 240px;
    font-size: 14px;
    color: white;
    padding: 16px 0 0 0;
  }

  .button-box {
    float: right;
    height: 67px;
    width: 230px;
    padding: 16px 0 0 30px;
  }

  @media (max-width: 700px) {
    display: none;
  }
`;

const ButtonStyled = styled.button`
  height: 36px;
  border-radius: 10px;
  cursor: pointer;
  background: transparent;
  border: 2px solid white;
  font-size: 14px;
  border-radius: 28px;
  color: white;
  width: 80%;
  &:hover {
    background: ;
`;